/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useEffect, useContext, useState } from 'react';
import React from 'react';
import { WsContext, WsContextType } from './WsContext';

ChartJS.register(       // keep unused stuff out of webpack
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const LiveBarInner = () => {
    const wsContext = useContext(WsContext) as WsContextType;
    const [data, setData] = useState<any>(null);

    const handlers = {
        liveBar: (msg: any) => {
            if (!msg) {
                return;
            }
            setData(msg);
        }
    };

    useEffect(() => {
        if (!wsContext.ws) {
            return;
        }
        wsContext.ws.on('liveBar', handlers.liveBar);
        return () => {
            wsContext.ws.off('liveBar', handlers.liveBar);
        }   
    }, [ wsContext ]);
    if (!data) {
        return null;
    }
    const options = {
        responsive: true,
        scales: {
            y: {
                min: 0, max: 100
            },
        },
        plugins: {
            legend: {
                display: false,
            }
        },
    };

    return <Bar data={data} options={options} />;
};

export const LiveBar = React.memo(LiveBarInner);